import React from 'react';
import Endpoints from "../components/Endpoints";
import Layout from "../layout";

const OrderObject = (props) => {
    return (
        <Layout children={props.children} location={props.location}>
            <div className="row">
                <div className="col-md-8">
                    <h1>Orders </h1>
                    <br/>
                    <p>Biteship provide an Order API from multiple couriers. This way, you can generate waybill number and pickup request at the same time. Giving you more flexibility and better customer experience for your platform. </p>
                    <br/>
                    <Endpoints
                        data={endpoints}
                    />
                </div>
            </div>
            <br/>
            To use Order API please contact <b>info@biteship.com</b>
            <hr/>
            
            <br/>
        </Layout>
    )
};

const endpoints = [{
    method:"POST",
    url: '/v1/orders'
},{
    method:"POST",
    url: '/v1/orders/:id/confirm'
},{
    method:"POST",
    url: '/v1/orders/:id'
},{
    method:"GET",
    url: '/v1/orders/:id'
},{
    method:"DELETE",
    url: '/v1/orders/:id'
}]

export default OrderObject